import React, { useState } from "react";
import PhoneInput from "../../../../components/PhoneInput";

export default function UserInformation({
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  error,
}) {
  return (
    <div className="p-3 w-full mx-auto">
      <h2 className="text-xl font-bold text-center md:text-left mb-6 text-gray-800 border-b pb-3">
        User Information
      </h2>

      <div className="space-y-6">
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Patient Name <span className="text-red-700">*</span>
          </label>
          <input
            type="text"
            className={`w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg 
                   focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                   transition-all duration-200 ease-in-out
                   placeholder:text-gray-400 ${
                     error.name != "" ? `border-red-500` : ""
                   }`}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Patient Name"
            required
          />
          <span className="text-red-400 text-sm font-medium">{error.name}</span>
        </div>

        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            className={`w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg 
              focus:ring-2 focus:ring-blue-500 focus:border-blue-500
              transition-all duration-200 ease-in-out
              placeholder:text-gray-400 ${
                error.email != "" ? `border-red-500` : ""
              }`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="optional"
          />
          <span className="text-red-400 text-sm font-medium">
            {error.email}
          </span>
        </div>
        <div className="relative">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Phone Number <span className="text-red-700">*</span>
          </label>
          <PhoneInput value={phone} onChange={setPhone} />
          <span className="text-red-400 text-sm font-medium">
            {error.phone}
          </span>
        </div>
      </div>
    </div>
  );
}
